import { createApiSlice } from "@common";
import { CRUD_EMPLOYEE_STATUS } from "@routes";

const apiConfig = [
  {
    name: "addEmployeeStatus",
    method: "post",
    url: CRUD_EMPLOYEE_STATUS,
    stateKey: "message"
  },
  {
    name: "getEmployeeStatus",
    method: "get",
    url: CRUD_EMPLOYEE_STATUS,
    stateKey: "data"
  },
  {
    name: "updateEmployeeStatus",
    method: "put",
    url: CRUD_EMPLOYEE_STATUS,
    stateKey: "message"
  },
  {
    name: "deleteEmployeeStatus",
    method: "delete",
    url: CRUD_EMPLOYEE_STATUS,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: []
  },
  reducers: {
    setAdditionalData:
      (state, action) => {
        state.additionalData = action.payload;
      },
  },
  extraReducers: {},
};

const { slice, thunks, actions } =
  createApiSlice("employeeCategory", apiConfig, customReducers);
const employeeCategorySlice = slice;

export default employeeCategorySlice.reducer;

export const {
  addEmployeeStatus,
  getEmployeeStatus,
  updateEmployeeStatus,
  deleteEmployeeStatus
} = thunks;
export const {
  rowSelect
} = actions;
